import { Api } from "./Api"
import { axiosInstance } from "./axios"
import { IRetailPoint } from "../interfaces/RetailPoint"

export class RetailPointService extends Api {
    protected PATH = 'v1/retail'

    get = async (params?: object) => {
        const groups = await axiosInstance.get<IRetailPoint[]>(`${this.URL}/${this.PATH}/`, {
            params: params
        })
        return groups.data
    }
}